import CategoryForm from '../../components/Forms/CategoryForm';
import { invalidUrlError, validateUrl } from '../../utils/functions';

const EventForm = ({ functionality }) => {
  const category = 'event';
  const fields = [
    { name: 'name', label: 'Event Name', type: 'text', required: true },
    { name: 'description', label: 'Description', type: 'text', required: true, text_area: true },
    { name: 'ticket_price', label: 'Ticket Price', type: 'text', placeholder: '$120' },
    {
      name: 'registration_link',
      label: 'Registration Link',
      type: 'text',
      required: true,
      placeholder: 'https://www.eventbrite.com/e/unlocking-leadership-support',
      pattern: validateUrl,
      title: invalidUrlError,
    },
    {
      name: 'type',
      label: 'Event Type',
      type: 'select',
      drop_down: true,
      required: true,
      options: [
        { value: 'Conference', label: 'Conference' },
        { value: 'Seminar', label: 'Seminar' },
        { value: 'Call for papers', label: 'Call for papers' },
        { value: 'Other', label: 'Other' },
      ],
    },
    { name: 'organizer', label: 'Organizer/Host', type: 'text', required: true },
    {
      name: 'date',
      label: 'Date',
      type: 'date',
      // required: true
    },
    {
      name: 'start_time',
      label: 'Start Time',
      type: 'time',
      //required: true
    },
    { name: 'end_time', label: 'End Time', type: 'time' },
    {
      name: 'location',
      label: 'Event Location and Format',
      type: 'text',
      required: true,
      placeholder: 'In-person, virtual, hybrid',
    },
    {
      name: 'registration_deadline',
      label: 'Registration Deadline',
      type: 'date',
      //required: true
    },
    { name: 'papers_call', label: 'Is there a call for papers?', type: 'text' },
    { name: 'submission_deadlines', label: 'Submission deadlines', type: 'text', text_area: true },
    {
      name: 'sponsorships',
      label: 'Opportunities for sponsorships',
      type: 'text',
      text_area: true,
    },
    { name: 'notes', label: 'Additional Notes', type: 'text', text_area: true },
    { name: 'image_url', label: 'Organization Logo', type: 'image' },
  ];

  return <CategoryForm functionality={functionality} category={category} fields={fields} />;
};
export default EventForm;
